"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const delta_1 = require("./delta");
const useQuill_1 = require("./useQuill");
const constants_1 = require("../../constants");
const Container = styled_1.default.div `
  display: flex;
  flex-direction: column;
  font-family: 'CircularStd', 'sans-serif';
  border-radius: ${constants_1.theme.border.radius.normal}px;
  overflow: hidden;

  .ql-container {
    flex: 1 1 auto;
  }

  .ql-editor {
    min-height: 300px;
    max-height: 700px;
    border-radius: ${constants_1.theme.border.radius.normal};
    overflow: hidden;
  }

  /* Adding some importance */
  .ql-toolbar.ql-toolbar {
    border: ${constants_1.theme.border.style.thin};
    background: ${constants_1.Color.LIGHT_GREY};
    border-radius: ${constants_1.theme.border.radius.normal}px
      ${constants_1.theme.border.radius.normal}px 0px 0px;
  }

  .ql-container.ql-container {
    border: ${constants_1.theme.border.style.thin};
    border-radius: 0px 0px ${constants_1.theme.border.radius.normal}px
      ${constants_1.theme.border.radius.normal}px;
  }
`;
const Editor = ({ className, onChange, onChangeDelta }) => {
    const [quillRef, quill] = (0, useQuill_1.useQuill)();
    (0, react_1.useEffect)(() => {
        if (!quill) {
            return;
        }
        const textChangeHandler = () => {
            const contents = quill.getContents();
            onChangeDelta?.(contents);
            const parser = new delta_1.ToMarkdown(contents.ops);
            onChange(parser.render());
        };
        quill.on('text-change', textChangeHandler);
        return () => {
            quill.off('text-change', textChangeHandler);
        };
    }, [quill]);
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, children: (0, jsx_runtime_1.jsx)("div", { ref: quillRef }) }));
};
exports.default = Editor;
